import {call, put, takeEvery} from 'redux-saga/effects'

import {formatAddressValues} from '../../reducers/checkout/helpers'
import * as checkoutActions from '../../actions/checkout'
import * as track from '../../track/track'
import {saveBillingInformationFromReduxForm} from './helpers'
import {REDUX} from '../../const'

export function* saveBillingAddressWorker() {
  yield put(checkoutActions.saveBillingAddressPending())

  try {
    const json = yield call(saveBillingInformationFromReduxForm, REDUX.CHECKOUT_BILLING_FORM)
    yield put(checkoutActions.saveBillingAddressSuccess(formatAddressValues('billing', json)))
  } catch (e) {
    yield put(checkoutActions.saveBillingAddressFailure(e))
  }
}

export function* saveBillingAddressSaga() {
  yield takeEvery(checkoutActions.SAVE_BILLING_ADDRESS, saveBillingAddressWorker)
}

export function* trackBillingFormSubmittedWorker() {
  yield call(track.checkoutSubmittedPaymentInfo, {isChargingCardOnFile: false})
}

export function* trackBillingFormSubmittedSaga() {
  yield takeEvery(checkoutActions.SAVE_BILLING_ADDRESS, trackBillingFormSubmittedWorker)
}
